import { axiosInstance } from "api/axios-config/axios-config";
import { DEFAULT_VOUCHER_SLICE_SIZE } from "commons/constants";
import { mapToDistinctOptionItems } from "commons/ultilities/option-item/option-item-ultil";
import {
  IAddWorkOrder,
  IUpdateWorkOrder,
  IWorkOrderProperties,
} from "mobx-stores/_models/work-order/work-order";
import { IUpdateDepartmentProcessItem } from "mobx-stores/_models/work-order/work-order-item";
import { BaseBussiness } from "../base";

class WorkOrderBusiness extends BaseBussiness<
  IWorkOrderProperties,
  IAddWorkOrder,
  IUpdateWorkOrder,
  IWorkOrderProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public updateDepartmentProcess = async (
    itemId: string,
    data: IUpdateDepartmentProcessItem,
  ) => {
    try {
      var res = await axiosInstance.put(
        `/api/app/work-order-item/${itemId}/part`,
        data,
      );
      return res.data;
    } catch (error) {
      console.error("Fail updateDepartmentProcess", error);
      return Promise.reject(error);
    }
  };

  public searchWOAsOptionItems = async (
    keyword: string,
    customerId?: string,
  ) => {
    const wos = await this.getLists({
      filter: keyword,
      maxResultCount: DEFAULT_VOUCHER_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
      customerId: customerId,
    });
    return mapToDistinctOptionItems(
      wos.items,
      (x) => x.id,
      (x) => x.woNumber,
    );
  };
}

export const workOrderBusiness = new WorkOrderBusiness("/api/app/work-order");
